import { Button, Stack, Typography } from '@mui/material'
import DocumentsWhiteSvg from '~/@ui/_sharedSvgs/ui/DocumentsWhite.svg?react'
import ViewSvg from '~/@ui/_sharedSvgs/ui/View.svg?react'

type Props = {
  title: string
  onClickView: () => void
  onClickDownload: () => void
  seen?: boolean
  className?: string
}

export const Document = ({
  title,
  onClickView,
  onClickDownload,
  seen,
  className = '',
}: Props) => {
  return (
    <Stack
      className={`gap-1 px-4 pt-4 pb-2 bg-zGrey200 rounded-4d ${className}`}>
      <Stack className="flex-row items-center gap-2">
        <DocumentsWhiteSvg className="w-9 h-9 px-[11px] py-1.5 bg-zBlack200 rounded-full" />
        <Typography className="text-base font-semibold text-zBlack200 flex-1 truncate max-w-full">
          {title}
        </Typography>
        {seen && (
          <Typography className="text-xs font-bold text-zGreen300">
            Videné
          </Typography>
        )}
      </Stack>
      <Stack className="flex-row justify-between items-center">
        <Button className="w-fit" onClick={onClickDownload}>
          <Typography className="text-xs font-medium text-zBlack200 underline">
            Sťiahnúť (PDF)
          </Typography>
        </Button>

        <Button className="w-fit gap-2" onClick={onClickView}>
          <Typography className="text-3d font-bold text-zBlack200">
            Zobraziť
          </Typography>
          <ViewSvg />
        </Button>
      </Stack>
    </Stack>
  )
}
